import { render, staticRenderFns } from "./ExchangeList.vue?vue&type=template&id=bfe305fa&"
import script from "./ExchangeList.vue?vue&type=script&lang=ts&"
export * from "./ExchangeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports